import { Dispatch, JSX, SetStateAction } from "react";
import { useTranslation } from "react-i18next";

import Button from "@/components/buttons/Button.tsx";
import KidsProfileCard from "@/components/cards/KidsProfileCard.tsx";
import { GateProfilePagesProps, ProfileTabs } from "@/components/gate/profiles/types.ts";
import { IconBack } from "@/components/icons/main.icons";

import { Profile } from "@/api/auth/auth.types.ts";

const KIDS_PROFILES = [
  {
    img: "/images/0+.png",
    hero_color: "radial-gradient(50% 50% at 50% 50%, rgb(193, 233, 255), rgb(78, 189, 251)), rgb(217, 217, 217)",
    hero_img: "/images/0_hero.png",
    profile_color: "linear-gradient(rgba(146, 75, 77, 0.6) 0%, rgba(146, 75, 77, 0.25) 100%)",
  },
  {
    img: "/images/6+.png",
    hero_color: "radial-gradient(50% 50% at 50% 50%, rgb(232, 201, 255), rgb(162, 41, 219)), rgb(217, 217, 217)",
    hero_img: "/images/6_hero.png",
    profile_color: "linear-gradient(rgba(232, 107, 163, 0.6) 0%, rgba(232, 107, 163, 0.25) 100%)",
  },
  {
    img: "/images/12+.png",
    hero_color: "radial-gradient(50% 50% at 50% 50%, rgb(255, 245, 191), rgb(242, 213, 59)), rgb(217, 217, 217)",
    hero_img: "/images/12_hero.png",
    profile_color: "linear-gradient(rgba(255, 102, 53, 0.6) 0%, rgba(255, 102, 53, 0.25) 100%)",
  },
];

interface ChooseKidProfileProps extends GateProfilePagesProps {
  profiles: Profile[];
  profileId?: number;
  setProfileId: Dispatch<SetStateAction<number | null>>;
}

const ChooseKidProfile = ({ profiles, setTab }: ChooseKidProfileProps): JSX.Element => {
  const { t } = useTranslation();
  const kidsProfiles = profiles.filter((profile) => profile.is_kids === true).reverse();

  return (
    <section className={"flex w-full max-w-[66.25rem] flex-col justify-center gap-8 max-md:gap-4"}>
      <div className={"gate-header"}>
        <Button
          color={"black"}
          size={"medium"}
          icon={<IconBack className={"stroke-on-primary size-5"} />}
          onClick={() => setTab(ProfileTabs.PROFILES)}
          aria-label={t("Actions.back")}
          className={"gate-back"}
        >
          <span>{t("Actions.back")}</span>
        </Button>
        <h1 className={"text-center text-[3.125rem]/[3.75rem] font-semibold max-md:text-2xl"}>
          {t("General.kids-platform")}
        </h1>
      </div>
      <div className={"flex flex-wrap justify-center gap-5 max-md:flex-col max-md:items-center"}>
        {kidsProfiles.map((profile, index) => (
          <KidsProfileCard
            key={profile.id}
            id={profile.id}
            age={profile.age || 0}
            name={profile.name}
            hero_img={KIDS_PROFILES[index].hero_img}
            hero_color={KIDS_PROFILES[index].hero_color}
            img={KIDS_PROFILES[index].img}
            profile_color={KIDS_PROFILES[index].profile_color}
            profile_img={profile.picture?.resized}
            reverse={index % 2 === 1}
          />
        ))}
      </div>
    </section>
  );
};

export default ChooseKidProfile;
